import { render, staticRenderFns } from "./Feature_group.vue?vue&type=template&id=2dc3bc90&"
import script from "./Feature_group.vue?vue&type=script&lang=js&"
export * from "./Feature_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports